import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const styles: Record<string, React.CSSProperties> = {
  title: {
    color: '#1a6b3c',
    marginBottom: '0.5rem',
    fontSize: '1.5rem',
    textAlign: 'center' as const,
  },
  subtitle: {
    color: '#666',
    marginBottom: '1.5rem',
    fontSize: '0.9rem',
    textAlign: 'center' as const,
  },
  field: {
    marginBottom: '1rem',
  },
  label: {
    display: 'block',
    marginBottom: '0.25rem',
    fontWeight: 600,
    fontSize: '0.85rem',
    color: '#333',
  },
  input: {
    width: '100%',
    padding: '0.6rem 0.75rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '1rem',
    boxSizing: 'border-box' as const,
  },
  button: {
    width: '100%',
    padding: '0.75rem',
    backgroundColor: '#1a6b3c',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: '0.5rem',
  },
  error: {
    color: '#d32f2f',
    backgroundColor: '#fdecea',
    padding: '0.5rem 0.75rem',
    borderRadius: '4px',
    marginBottom: '1rem',
    fontSize: '0.85rem',
  },
};

export function ChangePasswordPage() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { forceChangePassword } = useAuth();
  const navigate = useNavigate();

  // Voluntary self-service page — no longer gated on a forced-change flag.

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await forceChangePassword(newPassword);
      navigate('/my-weekend', { replace: true });
    } catch (err: unknown) {
      const apiError = err as { message?: string };
      setError(apiError.message || 'Failed to change password. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page attendee-page">
      <div className="login-page__card">
        <h1 style={styles.title}>Set Your Password</h1>
        <img src="/KDULogo.PNG" alt="KDU" style={{ width: '80px', height: '80px', objectFit: 'contain', margin: '0 auto 12px', display: 'block', borderRadius: '12px' }} />
        <p style={styles.subtitle}>Choose a new password for your account</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label} htmlFor="new-password">New Password</label>
            <input
              id="new-password"
              type="password"
              style={styles.input}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
              minLength={6}
              placeholder="Min. 6 characters"
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label} htmlFor="confirm-password">Confirm Password</label>
            <input
              id="confirm-password"
              type="password"
              style={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
              minLength={6}
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Saving...' : 'Set Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
